
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type garageRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function garageRT(): TemplateResult<garageRTRootProps> {
    return _createElement('div', { 'className': 'cm_garage' }, _createElement('a', {
        'className': 'cm_toggle-dropdown garage-button',
        'title': 'Garage: ' + this.size + ' item(s)',
        'tabIndex': '0',
        'role': 'button'
    }, _createElement('div', { 'className': 'garage-icon-container' }, _createElement('span', { 'className': 'icon-container' }, _createElement('svg', {
        'id': 'Layer_1',
        'xmlns': 'http://www.w3.org/2000/svg',
        'viewBox': '24.1 157.8 335.9 68.3',
        'width': '167.9',
        'height': '34.1'
    }, _createElement('rect', {
        'fill': '#e60000',
        'x': '24.1',
        'y': '157.8',
        'width': '335.9',
        'height': '68.3'
    }), _createElement('g', {}, _createElement('path', {
        'fill': '#ffffff',
        'd': 'M125.1,184.1l-4.2,1.9c-.5-2-1.5-3.2-3.1-3.2s-2.4,1.1-2.4,2.7.7,2.4,4.1,3.9c4.8,2.1,6,4.8,6,8.1,0,5.3-3.2,8.7-8.3,8.7s-7.2-2.5-8.1-7.4l4.5-1.6c.6,2.8,1.6,4,3.6,4s2.8-1.2,2.8-2.9-.8-2.4-2.5-3.2c-5.9-2.7-7.4-4.9-7.4-9.2s2.6-8,7.5-8,6.3,1.9,7.5,6.3Z'
    }), _createElement('path', {
        'fill': '#ffffff',
        'd': 'M133.7,178.3v10.8h4.2v-10.8h5.6v27.5h-5.6v-11.8h-4.2v11.8h-5.6v-27.5h5.6Z'
    }), _createElement('path', {
        'fill': '#ffffff',
        'd': 'M164,192.2c0,9.9-2.8,14-8.7,14s-8.5-5-8.5-14.5,2.9-13.8,8.7-13.8,8.5,4.4,8.5,14.3ZM155.5,201.3c2.2,0,2.6-1.5,2.6-9.3s-.3-9.2-2.7-9.2-2.6,4.3-2.6,9.5.3,9,2.7,9Z'
    }), _createElement('path', {
        'fill': '#ffffff',
        'd': 'M167.4,178.3h8.4c5.7,0,7.3,4.7,7.3,8.7s-2.3,8.6-7.5,8.6h-2.7v10.1h-5.5v-27.5ZM172.9,182.6v8.2h1.5c2.2,0,2.8-1.4,2.8-4.2s-1-4-2.8-4h-1.4Z'
    }), _createElement('path', {
        'fill': '#ffffff',
        'd': 'M195.9,178.3l2.1,7.8c.8,2.8.7,3,.7,5.2.2-2.2.2-2.8,1.1-5.7l2.2-7.4h5.1l-6.1,16.2v11.3h-5.6v-11.3l-5.5-16.2h5.9Z'
    }), _createElement('path', {
        'fill': '#ffffff',
        'd': 'M224.2,192.2c0,9.9-2.8,14-8.7,14s-8.5-5-8.5-14.5,2.9-13.8,8.7-13.8,8.5,4.4,8.5,14.3ZM215.7,201.3c2.2,0,2.6-1.5,2.6-9.3s-.3-9.2-2.7-9.2-2.6,4.3-2.6,9.5.3,9,2.7,9Z'
    }), _createElement('path', {
        'fill': '#ffffff',
        'd': 'M233,178.3v18.2c0,3.6.8,4.7,2.8,4.7s2.7-.7,2.7-4.9v-18h4.8v18.1c0,7.3-2.6,9.8-7.9,9.8s-8.1-3-8.1-9.9v-18h5.6Z'
    }), _createElement('path', {
        'fill': '#ffffff',
        'd': 'M247.2,178.3h8.7c5.2,0,7.1,4,7.1,8.2s-.8,5.7-3.6,7.4l4.2,11.9h-5.9l-3.1-10.8h-1.8v10.8h-5.5v-27.5ZM252.8,190.4h1.4c1.9,0,3.2-.8,3.2-4s-1.2-3.8-3.3-3.8h-1.3v7.8Z'
    }), _createElement('path', {
        'fill': '#ffffff',
        'd': 'M274.9,178.3h8.7c5.2,0,7.1,4,7.1,8.2s-.8,5.7-3.6,7.4l4.2,11.9h-5.9l-3.1-10.8h-1.8v10.8h-5.5v-27.5ZM280.4,190.4h1.4c1.9,0,3.2-.8,3.2-4s-1.2-3.8-3.3-3.8h-1.3v7.8Z'
    }), _createElement('path', {
        'fill': '#ffffff',
        'd': 'M299.5,178.3v27.5h-5.6v-27.5h5.6Z'
    }), _createElement('path', {
        'fill': '#ffffff',
        'd': 'M310.4,178.3c9.2,0,10.4,7.7,10.4,13.4,0,8.8-3.2,14.1-9.3,14.1h-7.7v-27.5h6.6ZM309.2,200.9h1.6c1,0,1.9-.2,2.5-.7,1.2-1,1.4-4.9,1.4-8.1,0-6.1-.6-9.1-3.5-9.1h-2v17.9Z'
    }), _createElement('path', {
        'fill': '#ffffff',
        'd': 'M338.4,178.3v4.8h-8.7v6.4h6.6v4.6h-6.6v6.9h8.7v4.8h-14.3v-27.5h14.3Z'
    })), _createElement('g', {}, _createElement('path', {
        'fill': '#ffffff',
        'd': 'M67.3,167.1v3h2.9v-3h.7l4.4.8c1.5.4,3,.9,4.3,1.7l-1.4,2.7,2.5,1.4,1.6-2.6c2.7,1.8,5.2,4,6.9,6.7l-2.3,1.5c-.1,0-.1.2,0,.3.2.6,1.2,1.6,1.3,2.3l2.5-1.4c.1,0,.2,0,.3,0,.2.2.9,2,1.1,2.3.4,1.1.8,2.3,1.1,3.5l.6,3.6v.7h-3v2.9h3v.7l-.6,3.6c-.3,1.2-.6,2.3-1.1,3.5s-.9,2.2-1.1,2.3-.1.1-.3,0l-2.5-1.4c-.2.7-1.2,1.7-1.3,2.3s0,.2,0,.3l2.3,1.5c-1.8,2.7-4.2,5-6.9,6.7l-1.6-2.6-2.5,1.4,1.4,2.7c0,.2-3.8,1.6-4.3,1.7l-4.4.8h-.7v-3h-2.9v3h-.7l-4-.7c-1.6-.4-3.1-1-4.6-1.7-.2-.1,0-.1,0-.2.1-.4,1.5-2.4,1.4-2.6l-2.5-1.4-1.5,2.6c-2.8-1.7-5.1-4-7-6.7,0-.1,0-.2.2-.2.3-.3,2.2-1.2,2.3-1.4l-1.4-2.5-2.7,1.4c-1.1-1.8-1.7-3.9-2.3-5.9l-.6-3.6v-.7h3v-2.9h-3c0-.2,0-.5,0-.7s0,0,0-.2c.3-3.3,1.2-6.5,2.8-9.4l2.7,1.4,1.4-2.5c0-.2-1.9-1.1-2.3-1.4s-.2,0-.2-.2c1.9-2.6,4.2-5,7-6.7l1.5,2.6,2.5-1.4c0-.1-1.2-2.2-1.4-2.6s-.1,0,0-.2c1.5-.7,3-1.3,4.6-1.7s2.7-.6,4-.7h.7ZM67.4,173.5c-12.7.8-20.8,14.3-15.6,26,5.5,12.5,22.3,15.1,31.2,4.6,10.7-12.6.9-31.7-15.5-30.6Z'
    }), _createElement('g', {}, _createElement('path', {
        'fill': '#ffffff',
        'd': 'M77.3,185.1c-.9,0-3.1,1.1-4.2,2.3-1.3,1.3-2.3,2.7-3.4,4.4h-1.1c-.2,0-.3.1-.3.3s.1.3.3.3h.8c-.7,1.2-1.6,2.5-2.6,4.1-2.8,4.3-4.7,5.2-7.4,5.2s-3.2-1.1-3.2-1.6.5-.5.5-1,0-.8-1-.8-1.2.6-1.2,1.4c0,1.5,1.8,2.4,5,2.4,5.6,0,8-3.2,9.8-5.5.9-1.2,1.9-2.8,2.7-4.2h1.9c.2,0,.3-.1.3-.3s-.1-.3-.3-.3h-1.6c.8-1.4,1.5-2.6,1.8-3.1.7-1,1.1-2,2.8-3.1.5-.3.8-.5.4-.5'
    }), _createElement('path', {
        'fill': '#ffffff',
        'd': 'M82.8,182.8c-.2,0-1.2.5-2.3.5-2.8,0-5.1-1.3-8.8-1.3s-6.4,1.1-8.9,3.1c-2.5,2-4,5.1-4,7.4s1.2,3.8,3.2,3.8,3.8-1.5,4.6-2.2c.8-.7.7-.8.6-.9-.2-.2-1.6,1.8-4,1.8s-2.9-1.5-2.9-3.4c0-3.7,3.6-8.6,9.2-8.6s4.9,1.2,8.9,1.2,4.4-.9,4.6-1,0-.3-.2-.2'
    }))))), this.size ? _createElement('span', {
        'className': 'garage-size',
        'key': '4008'
    }, this.size) : null), _createElement('span', { 'className': 'garage-label' }, _translate(`garage_title`))), [this.garageDropdown(function () {
            function repeatItems1(items, itemsIndex) {
                return [items(function () {
                        return _createElement('div', { 'className': 'garage-item' }, _createElement('span', {
                            'className': 'select-model',
                            'onClick': this.selectVehicle
                        }, this.vehicleString), _createElement('span', {
                            'className': 'remove-model',
                            'onClick': this.removeVehicle
                        }, [_createElement('svg', {
                                'className': 'cm_icon cm_icon-times',
                                'height': '20px',
                                'role': 'img',
                                'viewBox': '0 0 22 22',
                                'key': '1930'
                            }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))]));
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'cm_garageDropdown' }, this.template === 'list' ? _createElement('div', {
                'className': 'cmTemplate_list',
                'key': '31'
            }, _createElement('div', { 'className': 'garage-content' }, _createElement('div', {
                'className': 'clear-garage',
                'onClick': this.clearGarage
            }, _translate(`garage_clear`)), _createElement.apply(this, [
                'div',
                { 'className': 'cmRepeater_items' },
                _map(this.items, repeatItems1.bind(this))
            ]), [this.addButton(function () {
                    return _createElement('div', { 'className': 'add-vehicle  cm_button cm_button__primary cm_addButton' }, [window.Convermax.config?.garageButtonText || _translate(`garage_add_button`)]);
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })])) : null, this.template === 'empty' ? _createElement('div', {
                'className': 'cmTemplate_empty',
                'key': '1408'
            }, _createElement('div', { 'className': 'garage-content' }, [this.addButton(function () {
                    return _createElement('div', { 'className': 'add-vehicle  cm_button cm_button__primary cm_addButton' }, [window.Convermax.config?.garageButtonText || _translate(`garage_add_button`)]);
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })], _createElement('ul', {}, _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_one`)), _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_two`)), _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_three`))))) : null);
        }, {
            widgetName: 'undefined',
            items: undefined
        })]);
}
        export const componentNames = ["cm:addButton","cm:addButton","cm:garageDropdown"]